import React from 'react';
import './telegrambutton.css';

interface TelegramButtonProps {
    href: string;
}

const TelegramButton = ({href}: TelegramButtonProps): React.JSX.Element => {
    return (
        <a
            className="telegram-button"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Открыть Telegram-бота"
            title="Написать в поддержку"
        >
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                    fill="currentColor"
                    d="M21.944 2.506a1.5 1.5 0 0 0-1.533-.12L2.94 10.04a1.5 1.5 0 0 0 .105 2.79l4.409 1.565 1.686 5.153a1.5 1.5 0 0 0 2.532.545l2.413-2.48 4.548 3.348a1.5 1.5 0 0 0 2.36-.905L23.47 4.05a1.5 1.5 0 0 0-1.526-1.544ZM9.07 13.31l8.74-6.156-7.125 7.374-.67 2.937-.945-4.155Z"
                />
            </svg>
        </a>
    );
};

export default TelegramButton;
